<template>
  <div class="">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pdt-24 pdb-20">
        <div class="d-flex justify-content-center flex-column">
            <div class="t-center"><img src="/images/reward/no-data.svg" alt="" class="w-44 h-44 mgx-auto"></div>
            <div class="t-color-bodyGrayA t-body3 l-spacing42 t-center pdl-16 pdr-16 mgt-24 font-r">
                {{$t('696')}}
            </div>
        </div>
      </div>
    </div>
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  
};
</script>
